export default {
      id: "icon-pills-usage",
      viewBox: "0 0 43.893 44.109",
      url: __webpack_public_path__ + "icons.svg#icon-pills",
      toString: function () {
        return this.url;
      }
    }